import * as React from 'react';
import { useState } from 'react';
import { BookingEngineDialog } from './BookingEngineDialog';
import { useClientSettings } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/ClientSettingsContext';
import type { ReservationState } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/types';

interface Props {
    reservationState: ReservationState;
}

export const BookingEngineToolButton: React.FC<Props> = ({ reservationState }) => {
    const [showModal, setShowModal] = useState(false);
    const { isSuperAdmin } = useClientSettings();

    // Booking-engine confirmation/quote flow is mid-rollout — keep the staff entry point
    // superadmin-only in prod until it's signed off for general staff use.
    if (!isSuperAdmin) return null;
    if (!reservationState.ReservationId) return null;

    return (
        <>
            <button
                className="btn btn-outline-contrast"
                onClick={() => setShowModal(true)}
            >
                <i className="fa-solid fa-globe me-1"></i>
                Booking Engine
            </button>
            {showModal && (
                <BookingEngineDialog
                    reservationState={reservationState}
                    onClose={() => setShowModal(false)}
                />
            )}
        </>
    );
};
